module.exports = __webpack_public_path__ + "img/Mantle.121931ac.png";